module.exports = __webpack_public_path__ + "static/media/accountGrey.1aca3524.svg";